
import { defineComponent } from "vue";
import { mapActions } from "vuex";

interface NewPasswordViewData {
  password: string;
  passwordError: string;
  repeatPassword: string;
  repeatPasswordError: string;
  nonFieldErrors: string;
  globalError: string;
  isPasswordReset: boolean;
}

export default defineComponent({
  data(): NewPasswordViewData {
    return {
      password: "",
      repeatPassword: "",
      passwordError: "",
      repeatPasswordError: "",
      nonFieldErrors: "",
      globalError: "",
      isPasswordReset: false,
    };
  },
  methods: {
    ...mapActions("accounts", ["newPassword"]),
    handleResetPassword() {
      this.newPassword({
        password: this.password,
        repeatPassword: this.repeatPassword,
        uidb64: this.$route.params.uidb64,
        token: this.$route.params.token,
      }).then(({ success, errors }) => {
        if (success) {
          this.isPasswordReset = true;
        } else {
          this.passwordError = errors.password;
          this.repeatPasswordError = errors.repeatPassword;
          this.nonFieldErrors = errors.nonFieldErrors;
          this.globalError = errors.globalError;
        }
      });
    },
  },
  hideCarHeader: true,
});
